// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-header.bg-danger .modal-title,
.modal-header.bg-danger .close {
    color: white;
}


.fa-stack-sm {
    width: 1em !important;
    height: 1em !important;
    line-height: 1em !important;
}

.editable {
    cursor: pointer;
    padding: 4px !important;
}

    .editable:hover::after {
        font-family: "FontAwesome";
        content: "\\f040";
        color: #999999; /*text-muted*/
        margin-left: 4px;
    }

.editable-warning:hover {
    border: 1px solid #f0ad4e;
    cursor: pointer;
    padding: 3px !important;
}

.editable-success:hover {
    border: 1px solid #5cb85c;
    cursor: pointer;
    padding: 3px !important;
}

.editable-secondary:hover {
    border: 1px solid #6c757d;
    cursor: pointer;
    padding: 3px !important;
}

/*Vue modal*/
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
}

.modal-mask-front {
    z-index: 9999;
}

/*.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
}*/

/**/


.card-collapsable .card-header:after {
    font-family: 'FontAwesome';
    content: "\\f054";
    float: right;
}

.card-collapsable .card-header.collapsed:after {
    /* symbol for "collapsed" panels */
    content: "\\f078";
}

.nav-item a, .nav-link, a.dropdown-item, a.page-link, a.list-group-item, a.dropdown-toggle, a.text-primary, a.text-dark, a.btn-outline-secondary {
    cursor: pointer
}

a.text-primary:hover, a.text-dark:hover 
{
    text-decoration: underline !important;
}

.container.small {
    max-width: 500px;
    padding: 40px;
}

.container.medium {
    max-width: 700px;
    padding: 40px;
}

.border-box {
    padding: 30px;
    margin-bottom: 30px;
    border-radius: 6px;
    background-color: #eeeeee;
}

.pointer {
    cursor: pointer;
}
.pointer:hover {
    cursor: pointer;
    text-decoration: none;
}

.italic {
    font-style: italic;
}

div.error {
    color: red;
    font-size: 12px;
}

input.error, select.error, textarea.error {
    background-color: rgba(252, 66, 55, 0.25);
}

.text-ellipsis {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    word-break: break-all;
    word-wrap: break-word;
    display: block;
}

.text-ellipsis-inline {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    word-break: break-all;
    word-wrap: break-word;
    display: inline-block;
    vertical-align: bottom;
}

.no-display {
    display: none;
}

a.no-hover:hover 
{
    text-decoration: none;
    color: black;
}

.font-weight-normal {
    font-weight: normal;
}

.tile {
  display: block;
  padding: 8px;
  margin-bottom: 20px;
  line-height: 1.42857143;
  background-color: rgba(86, 86, 90, 0.1);
  border: 1px solid rgba(86, 86, 90, 0.3);
  border-radius: 4px;
  -webkit-transition: all .2s ease-in-out;
       -o-transition: all .2s ease-in-out;
          transition: all .2s ease-in-out;
}

.tile:hover {
  border-color: rgba(86, 86, 90, 0.5);
}

.tile:hover > * {
    text-decoration: none;
}

.context-menu {
    position: absolute; right: 20px; top: 5px;
}

.hovered-td
{
    visibility: collapse;
}
td:hover .hovered-td
{
    visibility: visible;
}

.hovered-tr
{
    visibility: collapse;
}
tr:hover .hovered-tr
{
    visibility: visible;
}


.dropdown-menu-scrollable
{
    max-height: 300px;
    overflow-y: auto;
}


.dropdown-submenu {
    position: relative;
}

.dropdown-submenu > .dropdown-menu {
    top: 0;
    left: 100%;
    margin-top: -6px;
    margin-left: -1px;
    -webkit-border-radius: 0 6px 6px 6px;
    -moz-border-radius: 0 6px 6px 6px;
    border-radius: 0 6px 6px 6px;
}

.dropdown-submenu:hover > .dropdown-menu {
    display: block;
}

.dropdown-submenu > a:after {
    display: block;
    content: " ";
    float: right;
    width: 0;
    height: 0;
    border-color: transparent;
    border-style: solid;
    border-width: 5px 0 5px 5px;
    border-left-color: #cccccc;
    margin-top: 5px;
    margin-right: -10px;
}

.dropdown-submenu:hover > a:after {
    border-left-color: #ffffff;
}

.dropdown-submenu.pull-left {
    float: none;
}

.dropdown-submenu.pull-left > .dropdown-menu {
    left: -100%;
    margin-left: 10px;
    -webkit-border-radius: 6px 0 6px 6px;
    -moz-border-radius: 6px 0 6px 6px;
    border-radius: 6px 0 6px 6px;
}


.bg-stripes{
    background-color: gray;
    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.2) 10%, transparent 10%, transparent 20%, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.2) 30%, transparent 30%, transparent 40%, rgba(255, 255, 255, 0.2) 40%, rgba(255, 255, 255, 0.2) 50%, transparent 50%, transparent 60%, rgba(255, 255, 255, 0.2) 60%, rgba(255, 255, 255, 0.2) 70%, transparent 70%, transparent 80%, rgba(255, 255, 255, 0.2) 80%, rgba(255, 255, 255, 0.2) 90%, transparent 90%);
}


.tch-margin-lg
{
    margin: 30px;
}

@media (max-width: 768px) 
{
    .tch-margin-lg
    {
        margin: 10px;
    }
}

/* Table browser  */

table.table-browser {
    margin-bottom: 150px !important;
}

    table.table-browser th {
        padding: 1em 1.5em !important;
        background-color: #f5f5f5;
    }

        table.table-browser th.selected {
            background-color: #e6e6e6 !important;
        }

        table.table-browser th.sortable {
            cursor: pointer;
        }

            table.table-browser th.sortable:hover {
                background-color: #e6e6f3 !important;
            }

            table.table-browser th.sortable .fa-stack {
                width: 1em;
            }

                table.table-browser th.sortable .fa-stack i {
                    color: #cecece;
                }

                    table.table-browser th.sortable .fa-stack i.selected {
                        color: gray;
                    }

    table.table-browser tbody td {
        padding: 1em 1.5em;
        vertical-align: middle;
    }


table.table-simple tbody td
{
    padding: 10px;
}`, "",{"version":3,"sources":["webpack://./App/Web/Styles/Layout.css"],"names":[],"mappings":"AAAA;;IAEI,YAAY;AAChB;;;AAGA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,uBAAuB;AAC3B;;IAEI;QACI,0BAA0B;QAC1B,gBAAgB;QAChB,cAAc,EAAE,aAAa;QAC7B,gBAAgB;IACpB;;AAEJ;IACI,yBAAyB;IACzB,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,uBAAuB;AAC3B;;AAEA,YAAY;AACZ;IACI,eAAe;IACf,aAAa;IACb,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,mCAAmC;IACnC,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,aAAa;AACjB;;AAEA;;;EAGE;;AAEF,GAAG;;;AAGH;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,kCAAkC;IAClC,gBAAgB;AACpB;;AAEA;IACI;AACJ;;AAEA;;IAEI,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;AACA;IACI,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,uCAAuC;EACvC,uCAAuC;EACvC,kBAAkB;EAClB,uCAAuC;OAClC,kCAAkC;UAC/B,+BAA+B;AACzC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB,EAAE,WAAW,EAAE,QAAQ;AAC7C;;AAEA;;IAEI,oBAAoB;AACxB;AACA;;IAEI,mBAAmB;AACvB;;AAEA;;IAEI,oBAAoB;AACxB;AACA;;IAEI,mBAAmB;AACvB;;;AAGA;;IAEI,iBAAiB;IACjB,gBAAgB;AACpB;;;AAGA;IACI,kBAAkB;AACtB;;AAEA;IACI,MAAM;IACN,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,oCAAoC;IACpC,iCAAiC;IACjC,4BAA4B;AAChC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,YAAY;IACZ,QAAQ;IACR,SAAS;IACT,yBAAyB;IACzB,mBAAmB;IACnB,2BAA2B;IAC3B,0BAA0B;IAC1B,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,oCAAoC;IACpC,iCAAiC;IACjC,4BAA4B;AAChC;;;AAGA;IACI,sBAAsB;IACtB,+cAA+c;AACnd;;;AAGA;;IAEI,YAAY;AAChB;;AAEA;;IAEI;;QAEI,YAAY;IAChB;AACJ;;AAEA,mBAAmB;;AAEnB;IACI,+BAA+B;AACnC;;IAEI;QACI,6BAA6B;QAC7B,yBAAyB;IAC7B;;QAEI;YACI,oCAAoC;QACxC;;QAEA;YACI,eAAe;QACnB;;YAEI;gBACI,oCAAoC;YACxC;;YAEA;gBACI,UAAU;YACd;;gBAEI;oBACI,cAAc;gBAClB;;oBAEI;wBACI,WAAW;oBACf;;IAEhB;QACI,kBAAkB;QAClB,sBAAsB;IAC1B;;;AAGJ;;IAEI,aAAa;AACjB","sourcesContent":[".modal-header.bg-danger .modal-title,\n.modal-header.bg-danger .close {\n    color: white;\n}\n\n\n.fa-stack-sm {\n    width: 1em !important;\n    height: 1em !important;\n    line-height: 1em !important;\n}\n\n.editable {\n    cursor: pointer;\n    padding: 4px !important;\n}\n\n    .editable:hover::after {\n        font-family: \"FontAwesome\";\n        content: \"\\f040\";\n        color: #999999; /*text-muted*/\n        margin-left: 4px;\n    }\n\n.editable-warning:hover {\n    border: 1px solid #f0ad4e;\n    cursor: pointer;\n    padding: 3px !important;\n}\n\n.editable-success:hover {\n    border: 1px solid #5cb85c;\n    cursor: pointer;\n    padding: 3px !important;\n}\n\n.editable-secondary:hover {\n    border: 1px solid #6c757d;\n    cursor: pointer;\n    padding: 3px !important;\n}\n\n/*Vue modal*/\n.modal-mask {\n    position: fixed;\n    z-index: 9998;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, .5);\n    display: table;\n    transition: opacity .3s ease;\n}\n\n.modal-mask-front {\n    z-index: 9999;\n}\n\n/*.modal-wrapper {\n    display: table-cell;\n    vertical-align: middle;\n}*/\n\n/**/\n\n\n.card-collapsable .card-header:after {\n    font-family: 'FontAwesome';\n    content: \"\\f054\";\n    float: right;\n}\n\n.card-collapsable .card-header.collapsed:after {\n    /* symbol for \"collapsed\" panels */\n    content: \"\\f078\";\n}\n\n.nav-item a, .nav-link, a.dropdown-item, a.page-link, a.list-group-item, a.dropdown-toggle, a.text-primary, a.text-dark, a.btn-outline-secondary {\n    cursor: pointer\n}\n\na.text-primary:hover, a.text-dark:hover \n{\n    text-decoration: underline !important;\n}\n\n.container.small {\n    max-width: 500px;\n    padding: 40px;\n}\n\n.container.medium {\n    max-width: 700px;\n    padding: 40px;\n}\n\n.border-box {\n    padding: 30px;\n    margin-bottom: 30px;\n    border-radius: 6px;\n    background-color: #eeeeee;\n}\n\n.pointer {\n    cursor: pointer;\n}\n.pointer:hover {\n    cursor: pointer;\n    text-decoration: none;\n}\n\n.italic {\n    font-style: italic;\n}\n\ndiv.error {\n    color: red;\n    font-size: 12px;\n}\n\ninput.error, select.error, textarea.error {\n    background-color: rgba(252, 66, 55, 0.25);\n}\n\n.text-ellipsis {\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    word-break: break-all;\n    word-wrap: break-word;\n    display: block;\n}\n\n.text-ellipsis-inline {\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    word-break: break-all;\n    word-wrap: break-word;\n    display: inline-block;\n    vertical-align: bottom;\n}\n\n.no-display {\n    display: none;\n}\n\na.no-hover:hover \n{\n    text-decoration: none;\n    color: black;\n}\n\n.font-weight-normal {\n    font-weight: normal;\n}\n\n.tile {\n  display: block;\n  padding: 8px;\n  margin-bottom: 20px;\n  line-height: 1.42857143;\n  background-color: rgba(86, 86, 90, 0.1);\n  border: 1px solid rgba(86, 86, 90, 0.3);\n  border-radius: 4px;\n  -webkit-transition: all .2s ease-in-out;\n       -o-transition: all .2s ease-in-out;\n          transition: all .2s ease-in-out;\n}\n\n.tile:hover {\n  border-color: rgba(86, 86, 90, 0.5);\n}\n\n.tile:hover > * {\n    text-decoration: none;\n}\n\n.context-menu {\n    position: absolute; right: 20px; top: 5px;\n}\n\n.hovered-td\n{\n    visibility: collapse;\n}\ntd:hover .hovered-td\n{\n    visibility: visible;\n}\n\n.hovered-tr\n{\n    visibility: collapse;\n}\ntr:hover .hovered-tr\n{\n    visibility: visible;\n}\n\n\n.dropdown-menu-scrollable\n{\n    max-height: 300px;\n    overflow-y: auto;\n}\n\n\n.dropdown-submenu {\n    position: relative;\n}\n\n.dropdown-submenu > .dropdown-menu {\n    top: 0;\n    left: 100%;\n    margin-top: -6px;\n    margin-left: -1px;\n    -webkit-border-radius: 0 6px 6px 6px;\n    -moz-border-radius: 0 6px 6px 6px;\n    border-radius: 0 6px 6px 6px;\n}\n\n.dropdown-submenu:hover > .dropdown-menu {\n    display: block;\n}\n\n.dropdown-submenu > a:after {\n    display: block;\n    content: \" \";\n    float: right;\n    width: 0;\n    height: 0;\n    border-color: transparent;\n    border-style: solid;\n    border-width: 5px 0 5px 5px;\n    border-left-color: #cccccc;\n    margin-top: 5px;\n    margin-right: -10px;\n}\n\n.dropdown-submenu:hover > a:after {\n    border-left-color: #ffffff;\n}\n\n.dropdown-submenu.pull-left {\n    float: none;\n}\n\n.dropdown-submenu.pull-left > .dropdown-menu {\n    left: -100%;\n    margin-left: 10px;\n    -webkit-border-radius: 6px 0 6px 6px;\n    -moz-border-radius: 6px 0 6px 6px;\n    border-radius: 6px 0 6px 6px;\n}\n\n\n.bg-stripes{\n    background-color: gray;\n    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.2) 10%, transparent 10%, transparent 20%, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.2) 30%, transparent 30%, transparent 40%, rgba(255, 255, 255, 0.2) 40%, rgba(255, 255, 255, 0.2) 50%, transparent 50%, transparent 60%, rgba(255, 255, 255, 0.2) 60%, rgba(255, 255, 255, 0.2) 70%, transparent 70%, transparent 80%, rgba(255, 255, 255, 0.2) 80%, rgba(255, 255, 255, 0.2) 90%, transparent 90%);\n}\n\n\n.tch-margin-lg\n{\n    margin: 30px;\n}\n\n@media (max-width: 768px) \n{\n    .tch-margin-lg\n    {\n        margin: 10px;\n    }\n}\n\n/* Table browser  */\n\ntable.table-browser {\n    margin-bottom: 150px !important;\n}\n\n    table.table-browser th {\n        padding: 1em 1.5em !important;\n        background-color: #f5f5f5;\n    }\n\n        table.table-browser th.selected {\n            background-color: #e6e6e6 !important;\n        }\n\n        table.table-browser th.sortable {\n            cursor: pointer;\n        }\n\n            table.table-browser th.sortable:hover {\n                background-color: #e6e6f3 !important;\n            }\n\n            table.table-browser th.sortable .fa-stack {\n                width: 1em;\n            }\n\n                table.table-browser th.sortable .fa-stack i {\n                    color: #cecece;\n                }\n\n                    table.table-browser th.sortable .fa-stack i.selected {\n                        color: gray;\n                    }\n\n    table.table-browser tbody td {\n        padding: 1em 1.5em;\n        vertical-align: middle;\n    }\n\n\ntable.table-simple tbody td\n{\n    padding: 10px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
